module.exports = __webpack_public_path__ + "static/media/banner3.d9ace546.png";